module.exports = __webpack_public_path__ + "static/media/unlink_white.6e994983.svg";